export const animalTypes = [
  'Krowy mleczne',
  'Jałówki',
  'Opasy',
  'Byki',
  'Cielaki',
  'Prosięta - cykl otwarty',
  'Tuczniki - cykl otwarty',
  'Tuczniki - cykl zamknięty',
  'Kurczęta brojlery',
  'Indyki',
  'Indyczki',
  'Kury nioski',
];

export const marks = [
  { value: 1, label: '1 rok' },
  { value: 2, label: '2 lata' },
  { value: 3, label: '3 lata' },
  { value: 4, label: '4 lata' },
  { value: 5, label: '5 lat' },
  { value: 6, label: '6 lat' },
  { value: 7, label: '7 lat' },
  { value: 8, label: '8 lat' },
];
